var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { attrs: { "aria-label": "Pagination" } }, [
    _c("ul", { staticClass: "c-pagination" }, [
      _c("li", { staticClass: "c-pagination__item" }, [
        _c(
          "button",
          {
            staticClass: "c-pagination__link--prev",
            attrs: {
              type: "button",
              rel: "prev",
              disabled: !_vm.showPreviousPage
            },
            on: { click: _vm.getPreviousPageResults }
          },
          [
            _c("span", { staticClass: "visually-hidden" }, [
              _vm._v("Previous page")
            ]),
            _vm._v(" "),
            _c(
              "svg",
              {
                staticClass: "c-pagination__link--prev-arrow",
                attrs: { focusable: "false", "aria-hidden": "true" }
              },
              [_c("use", { attrs: { "xlink:href": "#prev" } })]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showPreviousPage
        ? _c("li", { staticClass: "c-pagination__item" }, [
            _c(
              "button",
              {
                staticClass: "c-pagination__link",
                attrs: { type: "button", "aria-label": _vm.previousPageAria },
                on: { click: _vm.getPreviousPageResults }
              },
              [_vm._v(_vm._s(_vm.previousPageNumber))]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("li", { staticClass: "c-pagination__item is-active" }, [
        _c(
          "span",
          {
            staticClass: "c-pagination__current",
            attrs: { "aria-label": _vm.currentPageAria }
          },
          [_vm._v(_vm._s(_vm.currentPage))]
        )
      ]),
      _vm._v(" "),
      _vm.showNextPage
        ? _c("li", { staticClass: "c-pagination__item" }, [
            _c(
              "button",
              {
                staticClass: "c-pagination__link",
                attrs: { type: "button", "aria-label": _vm.nextPageAria },
                on: { click: _vm.getNextPageResults }
              },
              [_vm._v(_vm._s(_vm.nextPageNumber))]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("li", { staticClass: "c-pagination__item" }, [
        _c(
          "button",
          {
            staticClass: "c-pagination__link--next",
            attrs: { type: "button", rel: "next", disabled: !_vm.showNextPage },
            on: { click: _vm.getNextPageResults }
          },
          [
            _c("span", { staticClass: "visually-hidden" }, [
              _vm._v("Next page")
            ]),
            _vm._v(" "),
            _c(
              "svg",
              {
                staticClass: "c-pagination__link--next-arrow",
                attrs: { focusable: "false", "aria-hidden": "true" }
              },
              [_c("use", { attrs: { "xlink:href": "#next" } })]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-307bc95d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-307bc95d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/searches/results/SearchPaging.vue
// module id = 525
// module chunks = 0